export const PAGE_INIT = 'PAGE_INIT';

export function initPage(page, query = {}) {
  return {type: PAGE_INIT, payload: {page, query}};
}